import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import CreateFileNoteModal from '../modals/CreateFileNoteModal';
import LoaderContainer from 'commons/container/LoaderContainer';
import { useAddDocumentsMetaMutation, useGetDocMetaQuery, useRemoveDocumentMetaMutation, useUpdateDocumentsMetaMutation } from '../../../../redux/api/cache';

export default function FileNote(props) {
  const [createModal, setCreateModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [addDocumentsMeta] = useAddDocumentsMetaMutation();
  const [updateDocumentsMeta] = useUpdateDocumentsMetaMutation();
  const [removeDocumentMeta] = useRemoveDocumentMetaMutation();

  const { data, isLoading } = useGetDocMetaQuery(props.meta.rid);

  const fileClicked = (rowData) => {
    setSelectedRow(rowData);
    setCreateModal(true);
  };

  const remove = async () => {
    await removeDocumentMeta(selectedRow.rid);
  };

  const create = async (values) => {
    if (selectedRow === undefined) {
      await addDocumentsMeta(values);
    } else {
      await updateDocumentsMeta(values);
    }
  };

  return (
    <Fragment>
      {createModal && (
        <CreateFileNoteModal
          selectedRow={selectedRow}
          meta={props.meta}
          create={create}
          remove={remove}
          toggleDialog={() => {
            setCreateModal(false);
            setSelectedRow(undefined);
          }}
        />
      )}
      {!isLoading && (<GenericGrid
        autoSize={true}
        showCreateBtn={true}
        onCreateClick={() => {
          setSelectedRow(undefined);
          setCreateModal(true);
        }}
        rowClicked={fileClicked}
        definition={data.meta.definition}
        data={data.data.filter(d => d.docm_visible)}
        txtBtn="Ajouter une note"
      ></GenericGrid>)}
      {isLoading && <LoaderContainer style={{ height: '100px' }} />}
    </Fragment>
  );
}
FileNote.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.any,
    meta: PropTypes.shape({
      definition: PropTypes.any,
    }),
  }),
  mediaKey: PropTypes.any,
  update: PropTypes.any,
  meta: PropTypes.shape({
    rid: PropTypes.any,
  }),
};
